var React = require('react');

function Docs (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.8"},[React.createElement("path",{"stroke":"#3b4b6f","d":"M22.94 5.74H6.48L.9 11.53v26.26h22.04Z","key":0}),React.createElement("path",{"stroke":"#4a4aff","d":"M4.88 24.14h13","key":1}),React.createElement("path",{"stroke":"#4a4aff","d":"M4.88 28.11h13","key":2}),React.createElement("path",{"stroke":"#4a4aff","d":"M4.88 32.09h8.64","key":3}),React.createElement("path",{"stroke":"#3b4b6f","d":"M.9 11.53h5.58V.9h22.04v32.05h-5.58","key":4})]));
}

Docs.defaultProps = {"width":"29.42","height":"38.69"};

module.exports = Docs;

Docs.default = Docs;
